import React, { useContext } from 'react';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconBin({
  isAutoscallable = true,
  sizeKey = '23x22',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 23 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3685_63697)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.75 6.1875V19.25C19.75 19.9793 19.4603 20.6788 18.9445 21.1945C18.4288 21.7103 17.7293 22 17 22H15.625V20.625H17C17.3647 20.625 17.7144 20.4801 17.9723 20.2223C18.2301 19.9644 18.375 19.6147 18.375 19.25V6.1875H15.625C15.078 6.1875 14.5534 5.9702 14.1666 5.58341C13.7798 5.19661 13.5625 4.67201 13.5625 4.125V1.375H6C5.63533 1.375 5.28559 1.51987 5.02773 1.77773C4.76987 2.03559 4.625 2.38533 4.625 2.75V15.125H3.25V2.75C3.25 2.02065 3.53973 1.32118 4.05546 0.805456C4.57118 0.289731 5.27065 0 6 0L13.5625 0L19.75 6.1875Z"
          fill="#333333"
        />
        <path
          d="M5.2832 22.0381H3V17H5.44727C6.06478 17.0091 6.50228 17.188 6.75977 17.5366C6.91471 17.7508 6.99219 18.0072 6.99219 18.3057C6.99219 18.6133 6.91471 18.8605 6.75977 19.0474C6.67318 19.1522 6.54557 19.2479 6.37695 19.3345C6.63444 19.4279 6.82812 19.576 6.95801 19.7788C7.09017 19.9816 7.15625 20.2277 7.15625 20.5171C7.15625 20.8156 7.08105 21.0833 6.93066 21.3203C6.83496 21.4775 6.71533 21.6097 6.57178 21.7168C6.40999 21.8398 6.21859 21.9242 5.99756 21.9697C5.77881 22.0153 5.54069 22.0381 5.2832 22.0381ZM5.25928 19.8198H4.00488V21.1631H5.24219C5.46322 21.1631 5.63525 21.1335 5.7583 21.0742C5.98161 20.9648 6.09326 20.7552 6.09326 20.4453C6.09326 20.1833 5.98503 20.0033 5.76855 19.9053C5.64779 19.8506 5.47803 19.8221 5.25928 19.8198ZM5.78223 18.8594C5.91895 18.7773 5.9873 18.6304 5.9873 18.4185C5.9873 18.1838 5.89616 18.0288 5.71387 17.9536C5.55664 17.9012 5.35612 17.875 5.1123 17.875H4.00488V18.9858H5.24219C5.46322 18.9858 5.64323 18.9437 5.78223 18.8594Z"
          fill="#333333"
        />
        <path d="M7.95947 17H9.00537V22.0381H7.95947V17Z" fill="#333333" />
        <path
          d="M14.064 22.0381H13.0112L10.9536 18.4595V22.0381H9.97266V17H11.0767L13.083 20.5171V17H14.064V22.0381Z"
          fill="#333333"
        />
      </g>
      <defs>
        <clipPath id="clip0_3685_63697">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
